import { get } from 'lodash/fp'
import { CoachProfile } from 'src/legacy/models/firebase'

export const isCredentialedForParticipant = (
  coach: CoachProfile,
  stateOfResidence: string | null | undefined,
  credentialingHealthPlan: string | null | undefined
): boolean => {
  if (!stateOfResidence) return false
  const healthPlanKey = credentialingHealthPlan || 'general'
  return !!get(['regions', stateOfResidence, healthPlanKey], coach)
}
